import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "@/lib/api";

export default function WhatsAppFab() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-fab"
            data-testid="whatsapp-fab"
            aria-label="Contactar por WhatsApp"
        >
            <WhatsappLogo size={28} weight="fill" />
        </a>
    );
}
